function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504.123 504.123",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD05B"
    },
    cx: 252.062,
    cy: 252.062,
    r: 252.062
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.88,
    y: 94.523,
    style: {
      fill: "#54C0EB"
    },
    width: 40.566,
    height: 315.077
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.446,
    y: 94.523,
    style: {
      fill: "#84DBFF"
    },
    width: 210.314,
    height: 315.077
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M205.982,145.723v74.831c0,5.908,4.726,11.028,11.028,11.028h103.582 c5.908,0,11.028-4.726,11.028-11.028v-74.831c0-5.908-4.726-11.028-11.028-11.028H216.615 C210.708,135.089,205.982,139.815,205.982,145.723z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF7058"
    },
    points: "387.545,214.646 373.76,200.862 243.003,331.618 256.788,345.403 270.572,359.188  401.329,228.431 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M411.175,191.015c-7.483-7.483-20.086-7.483-27.569,0l-9.846,9.846l27.569,27.569l9.846-9.846 C418.658,211.102,418.658,198.498,411.175,191.015z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.192,
    y: 199.62,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 808.8516 103.1925)",
    style: {
      fill: "#FFFFFF"
    },
    width: 17.723,
    height: 38.99
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#324A5E"
    },
    points: "230.006,372.185 241.428,368.246 233.551,360.369 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "256.788,345.403 243.003,331.618 233.551,360.369 237.489,364.308 241.428,368.246  270.572,359.188 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 225.28,
    y: 156.751,
    style: {
      fill: "#ACB3BA"
    },
    width: 86.646,
    height: 7.877
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.28,
    y: 179.2,
    style: {
      fill: "#ACB3BA"
    },
    width: 86.646,
    height: 7.877
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.28,
    y: 202.043,
    style: {
      fill: "#ACB3BA"
    },
    width: 86.646,
    height: 7.877
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 139.028,
    cy: 140.603,
    r: 12.209
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M138.24,148.086h-26.782c-4.332,0-7.483-3.545-7.483-7.483l0,0c0-4.332,3.545-7.483,7.483-7.483 h26.782c4.332,0,7.483,3.545,7.483,7.483l0,0C145.723,144.935,142.572,148.086,138.24,148.086z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 139.028,
    cy: 185.108,
    r: 12.209
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M138.24,192.985h-26.782c-4.332,0-7.483-3.545-7.483-7.483l0,0c0-4.332,3.545-7.483,7.483-7.483 h26.782c4.332,0,7.483,3.545,7.483,7.483l0,0C145.723,189.44,142.572,192.985,138.24,192.985z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 139.028,
    cy: 229.612,
    r: 12.209
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M138.24,237.489h-26.782c-4.332,0-7.483-3.545-7.483-7.483l0,0c0-4.332,3.545-7.483,7.483-7.483 h26.782c4.332,0,7.483,3.545,7.483,7.483l0,0C145.723,233.945,142.572,237.489,138.24,237.489z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 139.028,
    cy: 274.511,
    r: 12.209
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M138.24,281.994h-26.782c-4.332,0-7.483-3.545-7.483-7.483l0,0c0-4.332,3.545-7.483,7.483-7.483 h26.782c4.332,0,7.483,3.545,7.483,7.483l0,0C145.723,278.449,142.572,281.994,138.24,281.994z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 139.028,
    cy: 319.015,
    r: 12.209
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M138.24,326.498h-26.782c-4.332,0-7.483-3.545-7.483-7.483l0,0c0-4.332,3.545-7.483,7.483-7.483 h26.782c4.332,0,7.483,3.545,7.483,7.483l0,0C145.723,322.954,142.572,326.498,138.24,326.498z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 139.028,
    cy: 363.52,
    r: 12.209
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M138.24,371.003h-26.782c-4.332,0-7.483-3.545-7.483-7.483l0,0c0-4.332,3.545-7.483,7.483-7.483 h26.782c4.332,0,7.483,3.545,7.483,7.483l0,0C145.723,367.458,142.572,371.003,138.24,371.003z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.c035ee94a18d87a3f558a634063cef3a.svg";
export { ForwardRef as ReactComponent };